import React from 'react'

const RenderUploadedImage = ({ imageURL }) => {
    console.log(imageURL ,"ttrtrtr")
    return (
        <div className="all-img-with-shadow">
            
            <figure>
                <img className="img-fluid" src={imageURL} 
                	style={{
						width: "100px",
						height: "100px",
						objectFit: "cover",
					}} />
            </figure>
            
        </div>
    )
}

export default RenderUploadedImage